import { render, staticRenderFns } from "./CampusEventsSearch.vue?vue&type=template&id=34de6d9f&"
import script from "./CampusEventsSearch.vue?vue&type=script&lang=js&"
export * from "./CampusEventsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports